export default "__VITE_ASSET__203ae94a__"